const RENDER_CHART_TOOL = 'render_chart';
const RENDER_TABLE_TOOL = 'render_table';

const DATASET_TOOL_PREFIX = 'query_';

/** Render tools leave a chart or table in the reply instead of a tool row. */
export const isRenderTool = (tool: string): boolean =>
  tool === RENDER_CHART_TOOL || tool === RENDER_TABLE_TOOL;

const MEMORY_TOOLS = new Set(['save_memory', 'forget_memory']);

export const isMemoryTool = (tool: string): boolean => MEMORY_TOOLS.has(tool);

/** Render and memory tools show a chart, table, or memory card instead of a tool row. */
export const showsToolRow = (tool: string): boolean =>
  !isRenderTool(tool) && !isMemoryTool(tool);

export const isDatasetTool =(tool: string): boolean =>
  tool.startsWith(DATASET_TOOL_PREFIX);

const TOOL_LABELS: Record<string, {running: string; done: string}> = {
  search_knowledge_base: {
    running: 'Searching the knowledge base...',
    done: 'Searched the knowledge base',
  },
  get_knowledge_article: {
    running: 'Reading a knowledge article...',
    done: 'Read a knowledge article',
  },
  list_knowledge_articles: {
    running: 'Listing knowledge articles...',
    done: 'Listed knowledge articles',
  },
  get_workflow: {
    running: 'Looking up a workflow...',
    done: 'Looked up a workflow',
  },
  [RENDER_CHART_TOOL]: {
    running: 'Drawing a chart...',
    done: 'Drew a chart',
  },
  [RENDER_TABLE_TOOL]: {
    running: 'Building a table...',
    done: 'Built a table',
  },
  save_memory: {
    running: 'Saving to memory...',
    done: 'Saved to memory',
  },
  forget_memory: {
    running: 'Updating memory...',
    done: 'Removed from memory',
  },
};

export const humanizeToolName = (tool: string): string =>
  tool.replace(/_/g, ' ');

/**
 * User-facing label for an assistant tool call; dataset tools (`query_<dataset>`) read as
 * "Queried <dataset>", unknown tools fall back to the humanized name.
 * @registry Running/done label for a Scout tool call (chat rows and transcript export).
 */
export const assistantToolLabel = (tool: string, running = false): string => {
  const known = TOOL_LABELS[tool];
  if (known) return running ? known.running : known.done;
  if (isDatasetTool(tool)) {
    const dataset = humanizeToolName(tool.slice(DATASET_TOOL_PREFIX.length));
    return running ? `Querying ${dataset}...` : `Queried ${dataset}`;
  }
  const humanized = humanizeToolName(tool);
  return running ? `${humanized}...` : humanized;
};
